module.exports = __webpack_public_path__ + "static/img/2.2.33f2273.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/eng/2.2.png
// module id = Owuh
// module chunks = 0